export default __webpack_public_path__ + "static/media/Logo-Shape.7b1409c3.png";